import React from 'react';
import { MultiSelect } from './MultiSelect';

interface CompanyMultiSelectProps {
  companies: { id: number; name: string }[];
  value: number[];
  onChange: (ids: number[]) => void;
  /** Gatilho em forma de chip de filtro ("Empresa: Todas ▾"). */
  chipLabel?: string;
  /** Valor do chip sem nada escolhido (padrão "Todas"; "" = só o rótulo). */
  allLabel?: string;
}

/**
 * MultiSelect de empresas: mapeamento id/name e placeholder em um lugar só —
 * consumido pelo Header (filtro global) e pela FiltersBar.
 *
 * Era `CostCenterMultiSelect` até 29/09/2026: o seletor global trocou de eixo
 * (centro de custo → empresa) porque 89 dos 112 internos que o viam tinham
 * 2+ CCs de uma ÚNICA empresa — um controle que não distinguia nada.
 */
export const CompanyMultiSelect: React.FC<CompanyMultiSelectProps> = ({
  companies,
  value,
  onChange,
  chipLabel,
  allLabel = 'Todas',
}) => (
  <MultiSelect
    options={companies.map((c) => ({ value: c.id, label: c.name }))}
    value={value}
    onChange={onChange}
    placeholder={chipLabel ? allLabel : 'Todas as empresas'}
    chipLabel={chipLabel}
  />
);
